import React, { useCallback, useRef } from "react";

/**
 * Pointer-tracked radial highlight. Writes --mx/--my on the wrapper and lets
 * CSS paint the gradient, so moving the pointer never triggers a React render.
 */
const Spotlight = ({
  children,
  className = "",
  radius = 380,
  intensity = 0.14,
  as: Tag = "div",
}) => {
  const ref = useRef(null);
  const frame = useRef(0);

  const handleMove = useCallback((e) => {
    const node = ref.current;
    if (!node || frame.current) return;
    const { clientX, clientY } = e;
    frame.current = requestAnimationFrame(() => {
      frame.current = 0;
      const rect = node.getBoundingClientRect();
      node.style.setProperty("--mx", `${clientX - rect.left}px`);
      node.style.setProperty("--my", `${clientY - rect.top}px`);
    });
  }, []);

  return (
    <Tag
      ref={ref}
      onPointerMove={handleMove}
      className={`spotlight ${className}`}
      style={{
        "--spot-radius": `${radius}px`,
        "--spot-intensity": intensity,
      }}
    >
      {children}
    </Tag>
  );
};

export default Spotlight;
